import React from 'react';
import { Chip } from '@mui/material';
import { AgentAvatar } from '../AgentAvatar';
import { IAgentBadge } from './interfaces';

export const AgentBadge: React.FC<IAgentBadge> = ({
  key,
  agent,
  size = 'small',
}): JSX.Element => {
  return (
    <Chip
      size={size}
      avatar={<AgentAvatar variant="pill" agent={agent} />}
      key={key}
      label={`${agent.firstName} ${agent.lastName}`}
    />
  );
};
